var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-service-page"},[(!_vm.kfUrl)?_c('div',{staticClass:"kf-fallback"},[_c('p',{staticClass:"kf-fallback-text"},[_vm._v("客服链接未配置，请联系管理员。")])]):_c('iframe',{ref:"kfIframe",staticClass:"kf-iframe-el",attrs:{"id":"kf-iframe","title":"在线客服","width":_vm.searchTableWidth}})])
}
var staticRenderFns = []

export { render, staticRenderFns }